import type {FC} from 'react';

import {Observer, observer} from 'mobx-react';

import {coreOrB2bEnvSwitcher} from '../../utils/coreOrB2b/CoreOrB2bEnvSwitcher';
import {TestID} from '../../utils/test-utils/data-test-id';
import {SwitchEnvButtonJSX} from './JSX';

type Props = {
  isCollapsed?: boolean;
};

export const SwitchEnvButton: FC<Props> = observer(({isCollapsed}) => {
  if (
    !coreOrB2bEnvSwitcher.isSwitchAvailable &&
    !coreOrB2bEnvSwitcher.shouldShowButtonTemporary
  ) {
    return null;
  }

  return (
    <Observer>
      {() => (
        <SwitchEnvButtonJSX
          env={coreOrB2bEnvSwitcher.oppositeEnv}
          hasUpdates={coreOrB2bEnvSwitcher.isOppositeEnvHasUpdates}
          onClick={() => coreOrB2bEnvSwitcher.toggleEnv()}
          testID={TestID.menu.button.switchEnv}
          variant={isCollapsed ? 'circle' : undefined}
        />
      )}
    </Observer>
  );
});
